function resolveBaseUrl () {
  const envUrl = (process.env.VUE_APP_API_URL || '').trim()
  const localCmsOrigin = (process.env.VUE_APP_CMS_ORIGIN || 'http://localhost:3000').trim()

  if (envUrl.startsWith('http://') || envUrl.startsWith('https://')) {
    return envUrl.replace(/\/$/, '')
  }

  // Se vier relativo (ex: /api/public), força origem do CMS para evitar bater no host do frontend.
  if (envUrl.startsWith('/')) {
    return `${localCmsOrigin}${envUrl}`.replace(/\/$/, '')
  }

  return 'http://localhost:3000/api/public'
}

const BASE_URL = resolveBaseUrl()

/**
 * Serviço de API para o Grupo Topázio
 */
const api = {
  /**
   * Requisição GET genérica
   */
  async get (endpoint) {
    try {
      const response = await fetch(`${BASE_URL}${endpoint}`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json'
        }
      })
      if (!response.ok) {
        const error = await response.json().catch(() => ({}))
        throw new Error(error.error || `Erro ${response.status}`)
      }
      const json = await response.json()
      return json.data
    } catch (error) {
      console.error(`[API] Erro em GET ${endpoint}:`, error)
      throw error
    }
  },

  // ========== HOME ==========
  /**
   * Dados da página inicial
   */
  async getHome () {
    return this.get('/home')
  },

  // ========== NAVEGAÇÃO ==========
  /**
   * Menu de navegação e configurações do site
   */
  async getNavigation () {
    return this.get('/navigation')
  },

  // ========== PRODUTOS ==========
  /**
   * Lista produtos de uma categoria
   * @param {string} categoria - Slug da categoria (ex: 'colchoes')
   * @param {string[]} specs - Valores das especificações selecionadas
   */
  async getProducts (categoria, specs = []) {
    const specQuery = specs.length
      ? `?${specs.map(s => `spec=${encodeURIComponent(s)}`).join('&')}`
      : ''
    return this.get(`/products/${categoria}${specQuery}`)
  },

  /**
   * Detalhes de um produto específico
   * @param {string} categoria - Slug da categoria
   * @param {string} slug - Slug do produto
   */
  async getProductDetails (categoria, slug) {
    return this.get(`/products/${categoria}/${slug}`)
  },

  // ========== PÁGINAS ==========
  /**
   * Conteúdo de uma página estática
   * @param {string} slug - Slug da página (ex: 'sobre', 'nossa-historia')
   */
  async getPage (slug) {
    return this.get(`/pages/${slug}`)
  },

  // ========== LOJAS ==========
  /**
   * Lista de lojas parceiras
   * @param {string} state - Sigla do estado para filtrar (opcional)
   */
  async getStores (state = null) {
    const query = state ? `?state=${state}` : ''
    return this.get(`/stores${query}`)
  },

  // ========== REPRESENTANTES ==========
  /**
   * Lista de representantes comerciais
   * @param {string} state - Sigla do estado para filtrar (opcional)
   */
  async getRepresentatives (state = null) {
    const query = state ? `?state=${state}` : ''
    return this.get(`/representatives${query}`)
  },

  // ========== CATÁLOGOS ==========
  /**
   * Lista de catálogos PDF
   * @param {string} state - Nome do estado para filtrar (opcional)
   */
  async getCatalogs (state = null) {
    const query = state ? `?state=${encodeURIComponent(state)}` : ''
    return this.get(`/catalogs${query}`)
  },

  // ========== TIMELINE ==========
  /**
   * Eventos da história da empresa
   */
  async getTimeline () {
    return this.get('/timeline')
  },

  // ========== BIO LINKS ==========
  /**
   * Links da página /links (estilo Linktree)
   */
  async getLinks () {
    return this.get('/links')
  }
}

export default api